import { render } from "./MessagesWindow.vue?vue&type=template&id=4075cd20"
import script from "./MessagesWindow.vue?vue&type=script&lang=js"
export * from "./MessagesWindow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\PCHOME\\projetos2022\\live-chat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__